import { z } from 'zod';

export const MAX_CENTS = 2_147_483_647;

export const centsSchema = z.number().int().min(0).max(MAX_CENTS);
